export default __webpack_public_path__ + "static/media/img-6.2b5fb252.jpeg";